import XLSX from 'xlsx';

export function parseXLSX(xlsx) {
  const workbook = XLSX.read(xlsx, { type: 'array' });
  const parsedXLSX = XLSX.utils.sheet_to_json(
    workbook.Sheets[workbook.SheetNames[1]],
    {
      header: 1,
    },
  );
  const variables = {
    x: {
      data: parsedXLSX.map((row) => row[0]),
      units: 'mL/100g',
      label: 'Oil volume per sample quantity',
    },
    y: {
      data: parsedXLSX.map((row) => row[1]),
      units: 'mNm',
      label: 'Torque',
    },
  };
  return variables;
}
